var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "SorterBagin"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("Bagging")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.BagLoading
    },
    on: {
      "update:active": function($event) {
        _vm.BagLoading = $event
      }
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2 radio"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedType),
      expression: "checkedType"
    }],
    attrs: {
      "type": "radio",
      "name": "bagging",
      "id": "bagging",
      "value": "bagging"
    },
    domProps: {
      "checked": _vm._q(_vm.checkedType, "bagging")
    },
    on: {
      "change": [function($event) {
        _vm.checkedType = "bagging"
      }, _vm.checkField]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "bagging"
    }
  }, [_vm._v("Default")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 radio"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedType),
      expression: "checkedType"
    }],
    attrs: {
      "type": "radio",
      "name": "directbagging",
      "id": "directbagging",
      "value": "directbagging"
    },
    domProps: {
      "checked": _vm._q(_vm.checkedType, "directbagging")
    },
    on: {
      "change": [function($event) {
        _vm.checkedType = "directbagging"
      }, _vm.checkField]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "directbagging"
    }
  }, [_vm._v("Direct (Heavies)")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 radio"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedType),
      expression: "checkedType"
    }],
    attrs: {
      "type": "radio",
      "name": "sorterbagging",
      "id": "sorterbagging",
      "value": "sorterbagging"
    },
    domProps: {
      "checked": _vm._q(_vm.checkedType, "sorterbagging")
    },
    on: {
      "change": [function($event) {
        _vm.checkedType = "sorterbagging"
      }, _vm.checkField]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "sorterbagging"
    }
  }, [_vm._v("Sorter Based")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [(_vm.sorterConfigFileName) ? _c('div', [_c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n                  Active File : \n                  "), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.sorterConfigFileName))])])]) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onGenerateBagin()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Bay Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-signs'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.bayTypeList,
      "selected-option": _vm.bayTypeData,
      "name": "BayType",
      "placeholder": "Select Bay Type"
    },
    on: {
      "select": _vm.selectBayType
    },
    model: {
      value: (_vm.bayTypeName),
      callback: function($$v) {
        _vm.bayTypeName = $$v
      },
      expression: "bayTypeName"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('BayType')),
      expression: "errors.has('BayType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('BayType')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Bay No.")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-signs'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.BayNoList,
      "selected-option": _vm.BayNoData,
      "name": "BayNo",
      "placeholder": "Select Bay No"
    },
    on: {
      "select": _vm.selectedBayNo
    },
    model: {
      value: (_vm.bayNo),
      callback: function($$v) {
        _vm.bayNo = $$v
      },
      expression: "bayNo"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('BayNo')),
      expression: "errors.has('BayNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('BayNo')))])], 1)], 1), _vm._v(" "), (_vm.isPTL) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("PTL ID")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.PTLNoList,
      "selected-option": _vm.PtlNoData,
      "name": "PTLID",
      "placeholder": "Select PTL No"
    },
    on: {
      "select": _vm.selectedPTLNo
    },
    model: {
      value: (_vm.PtlNo),
      callback: function($$v) {
        _vm.PtlNo = $$v
      },
      expression: "PtlNo"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('PTLID')),
      expression: "errors.has('PTLID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('PTLID')))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Destination")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Destination),
      expression: "Destination"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "Destination",
      "placeholder": "Select Destination",
      "id": "Destination",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.Destination)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Destination = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Route")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.route),
      expression: "route"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "route",
      "placeholder": "Select route",
      "id": "route",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.route)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.route = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Bag Type")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bagtype),
      expression: "bagtype"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "bagtype",
      "placeholder": "Select bagtype",
      "id": "bagtype",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.bagtype)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bagtype = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), (_vm.barcodeinput) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Bag Seal Number")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_vm._v("\">")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Bag Seal Number')),
      expression: "errors.has('Bag Seal Number')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Bag Seal Number')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorBagSealNo),
      expression: "errorBagSealNo"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errorBagSealNo))])], 1) : _vm._e(), _vm._v(" "), (!_vm.barcodeinput) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Bag Seal Number")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bagSealNumber),
      expression: "bagSealNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Bag Seal Number",
      "name": "Bag Seal Number",
      "id": "bagsealno",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.bagSealNumber)
    },
    on: {
      "click": _vm.scanBagSealNumber,
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bagSealNumber = $event.target.value
      }
    }
  }, 'input', _vm.colorCodeClassIcon(_vm.colorCodeBag, _vm.colorIconBag), false))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Bag Seal Number')),
      expression: "errors.has('Bag Seal Number')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Bag Seal Number')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorBagSealNo),
      expression: "errorBagSealNo"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errorBagSealNo))])], 1) : _vm._e(), _vm._v(" "), (_vm.cwbcode == 0 && _vm.iscwbFacility) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticStyle: {
      "font-size": "15px",
      "margin-top": "10%"
    }
  }, [_vm._v("\n                      Code:\n                      "), _c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("PRIMARY BAG")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('b-button', {
    staticClass: "common-secondary-btn",
    staticStyle: {
      "margin-bottom": "4px"
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.flagGerateBag == true
    }
  }, [_vm._v("Generate")]), _vm._v(" "), _c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.searchBag()
      }
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.resetBaginProcess()
      }
    }
  }, [_vm._v("Reset")])], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._v("Bag No : ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 bagin-dtl"
  }, [_vm._v(_vm._s(_vm.baginBagNo))])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._v("Bag Status : ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 bagin-dtl"
  }, [_vm._v(_vm._s(_vm.baginBagStatus))])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._v("Bag Type : ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 bagin-dtl"
  }, [_vm._v(_vm._s(_vm.baginBagType))])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.bagInscan.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("AWB No")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awbBag),
      expression: "awbBag"
    }],
    ref: "awbBag",
    class: {
      'form-control': true, 'error': _vm.errors.has('awbBag')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter AWB/Bag#",
      "name": "awbBag",
      "autocomplete": "off",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.awbBag)
    },
    on: {
      "keypress": function($event) {
        return _vm.validateBarcode($event)
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awbBag = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.awbBagErr),
      expression: "awbBagErr"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.awbBagErr))])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "35px"
    }
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.baginBagNo == false
    }
  }, [_vm._v("In Scan")]), _vm._v(" "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.resetInSacn()
      }
    }
  }, [_vm._v("Reset")])])], 1), _vm._v(" "), (_vm.showIconInput) ? _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "margin-bottom": "1%"
    }
  }, [_c('b-form-fieldset', [_c('b-input-group', _vm._b({}, 'b-input-group', _vm.colorCodeClassIcon(_vm.colorCode, _vm.colorIcon), false), [_vm._v(_vm._s(_vm.shipmentForColor))])], 1)], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('b-button', {
    staticClass: "--common-secondary",
    staticStyle: {
      "margin-top": "-5px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.flagUpdateSealNo == false
    },
    on: {
      "click": function($event) {
        return _vm.openBagSealNoModel()
      }
    }
  }, [_vm._v("Update Bag Seal No")]), _vm._v(" "), _c('b-button', {
    staticClass: "--common-secondary",
    staticStyle: {
      "margin-top": "-5px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.baginBagNo == '' || _vm.weight == ''
    },
    on: {
      "click": function($event) {
        return _vm.closeBag()
      }
    }
  }, [_vm._v("Close Bag")]), _vm._v(" "), (_vm.BagNoForColor) ? _c('b-form-fieldset', [_c('b-input-group', _vm._b({}, 'b-input-group', _vm.colorCodeClassIcon(_vm.colorCodeBag, _vm.colorIconBag), false), [_vm._v(_vm._s(_vm.BagNoForColor))])], 1) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-tabs', {
    staticStyle: {
      "border": "1px solid #cecece"
    },
    attrs: {
      "content-class": "mt-3"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Shipment Details"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "300px",
      "overflow": "auto"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticClass: "bagin-dtl"
  }, [_vm._v("Total Shipment Count : (" + _vm._s(_vm.inScanList.length) + ")")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "16px",
      "float": "right"
    },
    on: {
      "click": function($event) {
        return _vm.loadBagInShipmentList()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload this inscan list"
    }
  })]), _vm._v(" "), _c('table', {
    staticClass: "b-table table table-bordered"
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', [_vm._v("AWB No.")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("physical Weight")]), _vm._v(" "), _c('th', [_vm._v("volumetric Weight")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [(_vm.inScanList.length > 0) ? _vm._l((_vm.inScanList), function(row) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(row.shippingid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.physicalweight))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.volumetricweight))]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa fa-times-circle",
      staticStyle: {
        "cursor": "pointer",
        "font-size": "18px"
      },
      on: {
        "click": function($event) {
          return _vm.removeShipment(row.shippingid)
        }
      }
    })])])
  }) : [_c('tr', [_c('td', {
    attrs: {
      "colspan": "5",
      "align": "center"
    }
  }, [_vm._v("No record found")])])]], 2)])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v("Sticker Print")]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("Bag No for Sticker Print : "), _c('span', {
    staticClass: "bagin-dtl"
  }, [_vm._v(_vm._s(_vm.printBagStickerNo))])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-button', {
    staticClass: "--common-secondary",
    attrs: {
      "type": "button",
      "disabled": _vm.printBagStickerNo == false
    },
    on: {
      "click": _vm.loadBagDetails
    }
  }, [_vm._v("Print Bag Sticker-A4")])], 1)])])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.closeBagSealNoModel = false
      }
    },
    model: {
      value: (_vm.showBagSealNoModel),
      callback: function($$v) {
        _vm.showBagSealNoModel = $$v
      },
      expression: "showBagSealNoModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Update Bag Seal No.")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeBagSealNoModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("Seal Changed Reason : ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reason),
      expression: "reason"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "reason"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.reason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Reason")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Seal Broken while Bag Close"
    }
  }, [_vm._v("Seal Broken while Bag Close")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Seal Broken While Packing"
    }
  }, [_vm._v("Seal Broken While Packing")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Seal Damage"
    }
  }, [_vm._v("Seal Damage")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SealNo not Readable"
    }
  }, [_vm._v("SealNo not Readable")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reasonErr),
      expression: "reasonErr"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.reasonErr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("Old Bag Seal No: ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldSealNo),
      expression: "oldSealNo"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "disabled": true,
      "placeholder": "Old Bag Seal No",
      "name": "oldSealNo",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.oldSealNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldSealNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.oldSealNoErr),
      expression: "oldSealNoErr"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.oldSealNoErr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("New Bag Seal No: ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSealNo),
      expression: "newSealNo"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "New Bag Seal No",
      "name": "newSealNo",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.newSealNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newSealNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newSealNoErr),
      expression: "newSealNoErr"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.newSealNoErr))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updateBagSealNo()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.resetModalFields
    }
  }, [_vm._v("Reset")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    model: {
      value: (_vm.invalidTokenModal),
      callback: function($$v) {
        _vm.invalidTokenModal = $$v
      },
      expression: "invalidTokenModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(_vm._s(_vm.invalidtokenmsg))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_vm._v("Cancel")])])])])])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    model: {
      value: (_vm.XBSealModel),
      callback: function($$v) {
        _vm.XBSealModel = $$v
      },
      expression: "XBSealModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Update Seal")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeXBSealModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('span', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.IsAllowXBSeal),
      expression: "IsAllowXBSeal"
    }],
    attrs: {
      "type": "checkbox",
      "id": "IsAllowXBSeal",
      "value": "IsAllowXBSeal"
    },
    domProps: {
      "checked": Array.isArray(_vm.IsAllowXBSeal) ? _vm._i(_vm.IsAllowXBSeal, "IsAllowXBSeal") > -1 : (_vm.IsAllowXBSeal)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.IsAllowXBSeal,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "IsAllowXBSeal",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.IsAllowXBSeal = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.IsAllowXBSeal = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.IsAllowXBSeal = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check",
    staticStyle: {
      "cursor": "pointer"
    }
  })])]), _c('label', {
    attrs: {
      "for": "IsAllowXBSeal"
    }
  })])])]), _vm._v(" "), (_vm.IsAllowXBSeal == true) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Select Reason : ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.xbsealreason),
      expression: "xbsealreason"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "Reason"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.xbsealreason = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.clearXBReasonError]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select Reason")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SealNotAvailable"
    }
  }, [_vm._v("Seal not available")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SealBroken"
    }
  }, [_vm._v("Seal Broken")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.xbsealreasonErr),
      expression: "xbsealreasonErr"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.xbsealreasonErr))])], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.generateBag('IsXbSeal')
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeXBSealModel
    }
  }, [_vm._v("No")])])])])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1af10c6","hasScoped":true}!./src/views/components/SorterBagging/SorterBagging.html
// module id = 1951
// module chunks = 2